import { render } from "./configs-error.vue?vue&type=template&id=3a100e30&scoped=true"
import script from "./configs-error.vue?vue&type=script&lang=js"
export * from "./configs-error.vue?vue&type=script&lang=js"

import "./configs-error.vue?vue&type=style&index=0&id=3a100e30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a100e30"]])

export default __exports__